'use client'

import { getQueryClient } from '@shared/apis'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ReactQueryStreamedHydration } from '@tanstack/react-query-next-experimental'

type Props = {
  children: React.ReactNode
  debuggerMode?: boolean
}

export const TanstackQueryClientProvider = ({ children, debuggerMode = true }: Props) => {
  return (
    <QueryClientProvider client={getQueryClient()}>
      <ReactQueryStreamedHydration>{children}</ReactQueryStreamedHydration>
      {debuggerMode && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  )
}
